import React from 'react';
import ActiveAvmCompsTable from '../../../common/ActiveAvmCompsTable';
import { SoldAvmCompsTable } from '../../../common/SoldAvmCompsTable';
import { AvmComp, PropertyDataProps } from '../../../../utility/types';
import { SoldMlsNumbers } from './SoldMlsNumbers';
import AvmMap from '../../../common/maps/AvmMap';
import {
  getAvmCompsForMap,
  getAvmTopSix,
} from '../../../../utility/utility_functions';

type AvmCompsDisplayProps = {
  propertyDetails: PropertyDataProps;
  soldComps: { comps: AvmComp[] };
  activeComps: { comps: AvmComp[] };
};

export const AvmCompsDisplay = ({
  propertyDetails,
  soldComps,
  activeComps,
}: AvmCompsDisplayProps) => {
  const compsSixSold = getAvmTopSix(soldComps);
  const compsSixActive = getAvmTopSix(activeComps);
  const compsFifteenSold = soldComps?.comps?.slice(0, 15);
  const compsForMap = getAvmCompsForMap(compsSixActive, compsSixSold);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 mt-8">
      <div>
        <h3 className="whitespace-nowrap font-extrabold text-md mb-2 text-indigo-950 text-start">
          Top 6 Sold Comps
        </h3>
        <div className="shadow-xl rounded-xl overflow-x-auto w-contain mt-2 mb-10">
          <SoldAvmCompsTable comps={compsSixSold} />
        </div>
        <div>
          <h3 className="whitespace-nowrap font-extrabold text-md mt-4 mb-2 text-indigo-600 text-start">
            Top 6 Active Comps
          </h3>
          <div className="shadow-xl rounded-xl overflow-x-auto w-contain mb-10">
            <ActiveAvmCompsTable comps={compsSixActive} />
          </div>
        </div>
        <SoldMlsNumbers compsFifteenSold={compsFifteenSold} />
      </div>
      <div className="row-start-1 md:row-auto md:grid-col-2 h-96 md:h-full pb-4 md:pb-0 md:pl-6">
        <AvmMap property={propertyDetails} comps={compsForMap} />
      </div>
    </div>
  );
};
